import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@core/core.module';
import { SpinnerInterceptor } from '@core/interceptors/spinner.interceptor';
import { ComponentsModule } from 'src/app/components/components.module';
import { MaterialModule } from 'src/app/material.module';
import { PrimeNgModule } from 'src/app/primeng.module';
import { LogoTesterModule } from 'src/app/modules/programs/components/logo-tester/logo-tester.module';
import { CimaTesterComponent } from './components/cima-tester/cima-tester.component';
import { FlyersTesterComponent } from './components/flyers-tester/flyers-tester.component';
import { LogoFlowTesterComponent } from './components/logo-flow-tester/logo-flow-tester.component';
import { PriceSimulatorTesterComponent } from './components/price-simulator-tester/price-simulator-tester.component';
import { StriveTesterComponent } from './components/strive-tester/strive-tester.component';
import { FlowToolsRoutingModule } from './flow-tools-routing.module';
import { FlowToolsPageComponent } from './pages/flow-tools-page/flow-tools-page.component';

@NgModule({
  declarations: [
    FlowToolsPageComponent,
    StriveTesterComponent,
    PriceSimulatorTesterComponent,
    LogoFlowTesterComponent,
    FlyersTesterComponent,
    CimaTesterComponent,
  ],
  imports: [
    CommonModule,
    FlowToolsRoutingModule,
    FormsModule,
    MaterialModule,
    HttpClientModule,
    ReactiveFormsModule,
    CoreModule,
    PrimeNgModule,
    ComponentsModule,
    LogoTesterModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
  ],
})
export class FlowToolsModule {}
